





















import {defineComponent, ref} from "@vue/composition-api"
import {IExchangeCardProperties} from "@/shared/models/interface/exchangecard-properties-viewmodel"

export default defineComponent({
    name: "ExchangeCard",
    props: {
        label: {
            type: String,
            required: false
        },
        description: {
            type: String,
            required: false
        },
        completed: {
            type: Boolean,
            required: false
        },
        cardTitle: {
            type: String,
            required: false
        },
        hasInformation: {
            type: Boolean,
            required: false
        },
        depth: {
            type: Number,
            required: false,
            default: 1
        }
    },
    setup(props: IExchangeCardProperties) {
        const card = ref(null)
        const depth = Number(props.depth)
        const customMouseEnterEvent = new CustomEvent("informationSectionEvent", {
            detail: {
                informationTitle: props.label,
                informationText: props.description,
                offset: 0
            }
        })

        const customClickEvent = new CustomEvent("informationModalEvent", {
            detail: {
                informationTitle: props.label,
                informationText: props.description,
                offset: 0
            }
        })

        function getNode(element: any, count: any): HTMLDivElement {
            if (count === 0) {
                return element;
            }
            return getNode(element.parentElement, count - 1);
        }

        function onEnter(event: MouseEvent) {
            if(!props.label || !props.description) return
            const divElement = event.target as HTMLDivElement

            let parentElement = getNode(divElement, depth)
            let childElement = getNode(divElement, (depth > 0 ? depth - 1 : depth))
            
            let parentOffset = parentElement?.offsetTop ?? 0
            let childOffset = childElement.offsetTop
            let paddingOffset = 30

            customMouseEnterEvent.detail.offset = (childOffset - parentOffset) + paddingOffset
            window.document.dispatchEvent(customMouseEnterEvent)
        }

        function onInformationClick() {
            customClickEvent.detail.offset = document.documentElement.scrollTop || document.body.scrollTop;

            window.document.dispatchEvent(customClickEvent)
        }

        return {
            card,
            onEnter,
            onInformationClick
        }
    }
})
